import React, { forwardRef, TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  disableResize?: boolean;
  variant?: 'default' | 'clear';
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, disableResize = false, variant = 'default', ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'w-full min-h-24 text-sm text-text-primary outline-none transition duration-200',
          'placeholder:text-text-placeholder',
          variant === 'default' && [
            'rounded-lg border border-border-primary bg-bg-primary p-2.5 shadow-xs',
            'hover:border-border-brand hover:bg-bg-primary_hover',
            'focus:border-border-brand focus:ring-4 focus:ring-ring-brand/24',
            'disabled:cursor-not-allowed disabled:bg-bg-disabled disabled:text-text-disabled disabled:opacity-75',
          ],
          variant === 'clear' && 'bg-transparent border-none p-0 shadow-none',
          disableResize ? 'resize-none' : 'resize-y',
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
